import * as React from 'react';
import { Link } from 'gatsby';
import { Box, Container, Flex } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import Carousel from 'react-multi-carousel';
import '../styles/insights.scss';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1300 },
    items: 5,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1299, min: 991 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 990, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const AgronomyResearch = () => {
  return (
    <Box w="100%" p={4} className="insights-content-2">
      <Container className="insights-key-features" maxW={1400} marginTop={50}>
        <h4 className="insights-heading">More Agronomy Research</h4>

        <Carousel
          swipeable
          draggable={false}
          showDots={false}
          responsive={responsive}
          arrows={false}
          infinite
          autoPlay
          autoPlaySpeed={3000}
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
        >
          <Link to="/crop-data/corn">
            <Box className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/corn-icon.svg"
                alt="Ostara logo"
              />
              <p>Corn</p>
            </Box>
          </Link>
          <Link to="/crop-data/soybean">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/bean-icon.svg"
                alt="Ostara logo"
              />
              <p>Soybeans</p>
            </Flex>
          </Link>
          <Link to="/crop-data/spring-wheat">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/wheat-icon.svg"
                alt="Ostara logo"
              />
              <p>Spring Wheat</p>
            </Flex>
          </Link>
          <Link to="/crop-data/winter-wheat">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/winter-wheat-icon.svg"
                alt="Ostara logo"
              />
              <p>Winter Wheat</p>
            </Flex>
          </Link>
          <Link to="/crop-data/potato">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/potato.svg"
                alt="Ostara logo"
              />
              <p>Potato</p>
            </Flex>
          </Link>

          <Link to="/crop-data/canola">
            <Box className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/canola-icon.svg"
                alt="Ostara logo"
              />
              <p>Canola</p>
            </Box>
          </Link>
          <Link to="/crop-data/alfalfa">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/alfalfa.svg"
                alt="Ostara logo"
              />
              <p>Alfalfa</p>
            </Flex>
          </Link>
          <Link to="/crop-data/peas">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/peas-icon.svg"
                alt="Ostara logo"
              />
              <p>Peas</p>
            </Flex>
          </Link>
          <Link to="/crop-data/sugar-beets">
            <Flex className="insights-key-features--container">
              <StaticImage
                className="insights-key-features--icon"
                placeholder="transparent"
                src="../images/beets-icon.svg"
                alt="Ostara logo"
              />
              <p>Sugar Beets</p>
            </Flex>
          </Link>
        </Carousel>
      </Container>
    </Box>
  );
};

export default AgronomyResearch;
